import { Trans } from "react-i18next";

export const getTechFilterNameKey = (code: string) => {
  return `facet.${code}.name`;
};

export const getTechFilterSymbolKey = (code: string) => {
  return `facet.${code}.symbol`;
};

export const getTechFilterUnitKey = (code: string) => {
  return `facet.${code}.unit`;
};

export function getTechFilterTranslations(code: string) {
  const [name, symbol, unit] = [getTechFilterNameKey, getTechFilterSymbolKey, getTechFilterUnitKey].map((fn) => (
    <Trans i18nKey={fn(code)} />
  ));

  return {
    name,
    symbol,
    unit,
  };
}
